import React from "react"
import style from "./Badge.module.scss"
import { Badge } from "../data/badges"

interface BadgeProps {
  badge: Badge
}

export const BadgeComponent: React.FC<BadgeProps> = ({ badge }) => {
  return (
    <span className={style.badge} style={{ backgroundColor: badge.color }}>
      {badge.title}
    </span>
  )
}
